import React from 'react';
import mountReactApp from 'mount-react-app';
import {routes, reducers} from 'myaccount';
import {getter} from '../common/client-side-storage/src/client-side-storage.web'

function renderApp() {
  const initialState = window.__initial_state__;
  const mmtAuthObject = getter('myPartnerAuth');
  if(mmtAuthObject && mmtAuthObject.mmt_auth) {
    initialState.myaccount.authToken = mmtAuthObject.mmt_auth;
  } 
  mountReactApp({
    routes,
    reducers,
    initialState
  });
}

renderApp();

if (module.hot) {
  module.hot.accept('myaccount', () => renderApp());
}
